<div class="filter-sort-form" *ngIf="model && model.filterBy">
  <div class="d-flex flex-wrap justify-content-between">
    <rr-checkbox-field
      [(ngModel)]="model.filterBy.value"
      (ngModelChange)="changeCheckbox($event)"
      [settings]="checkboxSettings"
      [options]="options"
    >
    </rr-checkbox-field>
  </div>
</div>
